import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_3 = { class: "control-label col-sm-6" }
const _hoisted_4 = { class: "col-sm" }
const _hoisted_5 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_6 = { class: "control-label col-sm-6" }
const _hoisted_7 = { class: "col-sm" }
const _hoisted_8 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_9 = { class: "control-label col-sm-6" }
const _hoisted_10 = { class: "col-sm" }
const _hoisted_11 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_12 = { class: "control-label col-sm-6" }
const _hoisted_13 = { class: "col-sm" }
const _hoisted_14 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_15 = { class: "control-label col-sm-6" }
const _hoisted_16 = { class: "col-sm" }
const _hoisted_17 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_18 = { class: "control-label col-sm-6" }
const _hoisted_19 = { class: "col-sm" }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_22 = { class: "control-label col-sm-6" }
const _hoisted_23 = { class: "col-sm" }
const _hoisted_24 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_25 = { class: "control-label col-sm-6" }
const _hoisted_26 = { class: "col-sm" }
const _hoisted_27 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_28 = { class: "control-label col-sm-6" }
const _hoisted_29 = { class: "col-sm" }
const _hoisted_30 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_31 = { class: "control-label col-sm-6" }
const _hoisted_32 = { class: "col-sm" }
const _hoisted_33 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_34 = { class: "control-label col-sm-6" }
const _hoisted_35 = { class: "col-sm" }
const _hoisted_36 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_37 = { class: "control-label col-sm-6" }
const _hoisted_38 = { class: "col-sm" }
const _hoisted_39 = { key: 2 }
const _hoisted_40 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_41 = { class: "control-label col-sm-6" }
const _hoisted_42 = { class: "col-sm" }
const _hoisted_43 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_44 = { class: "control-label col-sm-6" }
const _hoisted_45 = { class: "col-sm" }
const _hoisted_46 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_47 = { class: "control-label col-sm-6" }
const _hoisted_48 = { class: "col-sm" }
const _hoisted_49 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_50 = { class: "control-label col-sm-6" }
const _hoisted_51 = { class: "col-sm" }

import { ref, watch , inject} from 'vue'
import { usePreventivo } from '../../composable/usePreventivo'
import FormImmobiliareHelper from "./../../pages/preventivi/json/immobiliare/helper.json";
import DettaglioPreventivoHelper from "./../../pages/preventivi/json/dettagliopreventivo/helper.json";
import CalcoloEquoCompenso from "./CalcoloEquoCompenso.vue";
import RegimeFiscale from "./RegimeFiscale.vue";
import AliquoteContributiRepertoriali from "./AliquoteContributiRepertoriali.vue";

export default {
  __name: 'FormImmobiliareMutuoSurroga',
  props: {
  formName: String,
  tipoPreventivo: Object,
  disabilita: Boolean,
  readonly: Boolean
},
  emits: ['changeDatiPreventivo','infoCompilazione'],
  setup(__props, { emit: __emit }) {

const emits = __emit;
const {
  categoriaImmobiliare
} = usePreventivo();
const props = __props;
let validazione;
const validazioneEquoCompenso = ref();
const { regimeFiscale } = inject('regimeFiscale')
switch (props.formName) {
  case 'mutuoFondiarioIpotecario':
    validazione = categoriaImmobiliare['sottocategoriaMutuoSurroga']['mutuoFondiarioIpotecario'];
    validazioneEquoCompenso.value = categoriaImmobiliare['sottocategoriaMutuoSurroga']['mutuoFondiarioIpotecario'];
    break
  case 'mutuoSurroga':
    validazione = categoriaImmobiliare['sottocategoriaMutuoSurroga']['mutuoSurroga'];
    validazioneEquoCompenso.value = categoriaImmobiliare['sottocategoriaMutuoSurroga']['mutuoSurroga'];
    break
  case 'quietanzaPerSurrogazione':
    validazione = categoriaImmobiliare['sottocategoriaMutuoSurroga']['quietanzaPerSurrogazione'];
    validazioneEquoCompenso.value = categoriaImmobiliare['sottocategoriaMutuoSurroga']['quietanzaPerSurrogazione'];
    break
}
// Aggiungiamo il valore a tipo_parametro che sarà un path alla pagina (mantenendo il nome)
if(validazione){
  validazione.tipo_preventivo.value = 'immobiliare/mutuo_surroga/' + props.tipoPreventivo.data.url
}

const testoInfoCompilazione = ref([]);
emits('infoCompilazione',  testoInfoCompilazione);
watch(validazione, (newValue) => {
  validazione.valore_erogato.required = newValue.abilitare_equo_compenso.value === '1';
  emits('changeDatiPreventivo');
}, { deep: true })
testoInfoCompilazione.value =  FormImmobiliareHelper.sottocategoriaMutuoSurroga[props.formName];
let indexHelperClosing = {
  calcolo: FormImmobiliareHelper.sottocategoriaMutuoSurroga[props.formName],
  dettaglio: DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni
}

return (_ctx, _cache) => {
  const _component_the_helper = _resolveComponent("the-helper")
  const _component_base_input_text = _resolveComponent("base-input-text")
  const _component_base_select = _resolveComponent("base-select")
  const _component_base_input_checkbox = _resolveComponent("base-input-checkbox")
  const _directive_fallcohelper = _resolveDirective("fallcohelper")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_the_helper, {
      list: _unref(indexHelperClosing),
      "is-closing": true
    }, null, 8 /* PROPS */, ["list"]),
    (__props.formName === 'mutuoFondiarioIpotecario')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_3, [
              _createTextVNode(_toDisplayString(_unref(validazione).valore_ipoteca.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_ipoteca.ref]
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_base_input_text, {
                id: "valore_ipoteca",
                name: "valore_ipoteca",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).valore_ipoteca,
                "onUpdate:validateTo": _cache[0] || (_cache[0] = $event => ((_unref(validazione).valore_ipoteca) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_6, [
              _createTextVNode(_toDisplayString(_unref(validazione).valore_erogato.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_erogato.ref]
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_base_input_text, {
                id: "valore_erogato",
                name: "valore_erogato",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).valore_erogato,
                "onUpdate:validateTo": _cache[1] || (_cache[1] = $event => ((_unref(validazione).valore_erogato) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_9, [
              _createTextVNode(_toDisplayString(_unref(validazione).tipo_mutuo.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tipo_mutuo.ref]
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_base_select, {
                name: "tipo_mutuo",
                options: [{name: 'Fondiario', value: 'fondiario'},{name: 'Ipotecario', value: 'ipotecario'}],
                isSelected: _unref(validazione).tipo_mutuo.value !== '',
                state: __props.readonly === true ?'disable':'',
                validateTo: _unref(validazione).tipo_mutuo,
                "onUpdate:validateTo": _cache[2] || (_cache[2] = $event => ((_unref(validazione).tipo_mutuo) = $event))
              }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_12, [
              _createTextVNode(_toDisplayString(_unref(validazione).forma_del_titolo.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.forma_del_titolo.ref]
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_base_select, {
                name: "forma_del_titolo",
                options: [{name: 'Pubblico', value: 'pubblico'},{name: 'Privato', value: 'privato'}],
                isSelected: _unref(validazione).forma_del_titolo.value !== '',
                state: __props.readonly === true ?'disable':'',
                validateTo: _unref(validazione).forma_del_titolo,
                "onUpdate:validateTo": _cache[3] || (_cache[3] = $event => ((_unref(validazione).forma_del_titolo) = $event))
              }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_15, [
              _createTextVNode(_toDisplayString(_unref(validazione).si_collegato_alla_cv.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.si_collegato_alla_cv.ref]
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_base_input_checkbox, {
                class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                name: "si_collegato_alla_cv",
                label: "Sì, è collegato",
                "validate-to": _unref(validazione).si_collegato_alla_cv,
                "onUpdate:validateTo": _cache[4] || (_cache[4] = $event => ((_unref(validazione).si_collegato_alla_cv) = $event))
              }, null, 8 /* PROPS */, ["class", "validate-to"])
            ])
          ]),
          (_unref(regimeFiscale) === 'ordinario')
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_18, [
                  _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_base_input_checkbox, {
                    class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                    name: "ritenuta_acconto",
                    label: "Si, applicabile",
                    "validate-to": _unref(validazione).ritenuta_acconto,
                    "onUpdate:validateTo": _cache[5] || (_cache[5] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                  }, null, 8 /* PROPS */, ["class", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createVNode(RegimeFiscale, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(AliquoteContributiRepertoriali, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(CalcoloEquoCompenso, {
            "input-riferimento-calcolo": "valore_erogato",
            validazione: validazioneEquoCompenso.value,
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
        ]))
      : (__props.formName === 'mutuoSurroga')
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_22, [
                _createTextVNode(_toDisplayString(_unref(validazione).tipo_surroga.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tipo_surroga.ref]
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_base_select, {
                  name: "tipo_surroga",
                  options: [{name: 'Bilaterale', value: 'bilaterale'},{name: 'Trilaterale', value: 'trilaterale'}],
                  isSelected: _unref(validazione).tipo_surroga.value !== '',
                  state: __props.readonly === true ?'disable':'',
                  validateTo: _unref(validazione).tipo_surroga,
                  "onUpdate:validateTo": _cache[6] || (_cache[6] = $event => ((_unref(validazione).tipo_surroga) = $event))
                }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_25, [
                _createTextVNode(_toDisplayString(_unref(validazione).numero_annotamenti.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.numero_annotamenti.ref]
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_base_input_text, {
                  id: "numero_annotamenti",
                  name: "numero_annotamenti",
                  class: "placeholder-right crm:text-right",
                  placeholder: "Indicare il numero annotamenti",
                  disabled: __props.readonly,
                  "validate-to": _unref(validazione).numero_annotamenti,
                  "onUpdate:validateTo": _cache[7] || (_cache[7] = $event => ((_unref(validazione).numero_annotamenti) = $event))
                }, null, 8 /* PROPS */, ["disabled", "validate-to"])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_28, [
                _createTextVNode(_toDisplayString(_unref(validazione).valore_surrogato.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_surrogato.ref]
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_base_input_text, {
                  id: "valore_surrogato",
                  name: "valore_surrogato",
                  class: "placeholder-right",
                  placeholder: "0,00",
                  disabled: __props.readonly,
                  "validate-to": _unref(validazione).valore_surrogato,
                  "onUpdate:validateTo": _cache[8] || (_cache[8] = $event => ((_unref(validazione).valore_surrogato) = $event))
                }, null, 8 /* PROPS */, ["disabled", "validate-to"])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_31, [
                _createTextVNode(_toDisplayString(_unref(validazione).onorario.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.onorario.ref]
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_base_select, {
                  name: "onorario",
                  state: __props.readonly === true ?'disable':'',
                  options: [
          {name: 'Grado 100', value: 'grado_100'},
          {name: 'Grado 50', value: 'grado_50'},
          {name: 'Grado 25', value: 'grado_25'},
          {name: 'Onorario fisso', value: 'onorario_fisso'}
          ],
                  isSelected: _unref(validazione).onorario.value !== '',
                  validateTo: _unref(validazione).onorario,
                  "onUpdate:validateTo": _cache[9] || (_cache[9] = $event => ((_unref(validazione).onorario) = $event))
                }, null, 8 /* PROPS */, ["state", "isSelected", "validateTo"])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_34, [
                _createTextVNode(_toDisplayString(_unref(validazione).forma_del_titolo.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.forma_del_titolo.ref]
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_base_select, {
                  name: "forma_del_titolo",
                  options: [{name: 'Pubblico', value: 'pubblico'},{name: 'Privato', value: 'privato'}],
                  isSelected: _unref(validazione).forma_del_titolo.value !== '',
                  state: __props.readonly === true ?'disable':'',
                  validateTo: _unref(validazione).forma_del_titolo,
                  "onUpdate:validateTo": _cache[10] || (_cache[10] = $event => ((_unref(validazione).forma_del_titolo) = $event))
                }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
              ])
            ]),
            (_unref(regimeFiscale) === 'ordinario')
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_37, [
                    _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(_component_base_input_checkbox, {
                      class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                      name: "ritenuta_acconto",
                      label: "Si, applicabile",
                      "validate-to": _unref(validazione).ritenuta_acconto,
                      "onUpdate:validateTo": _cache[11] || (_cache[11] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                    }, null, 8 /* PROPS */, ["class", "validate-to"])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createVNode(RegimeFiscale, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(AliquoteContributiRepertoriali, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(CalcoloEquoCompenso, {
              "input-riferimento-calcolo": "valore_surrogato",
              validazione: validazioneEquoCompenso.value,
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
          ]))
        : (__props.formName === 'quietanzaPerSurrogazione')
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_41, [
                  _createTextVNode(_toDisplayString(_unref(validazione).valore_quietanza.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_quietanza.ref]
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createVNode(_component_base_input_text, {
                    id: "valore_quietanza",
                    name: "valore_quietanza",
                    class: "placeholder-right",
                    placeholder: "0,00",
                    disabled: __props.readonly,
                    "validate-to": _unref(validazione).valore_quietanza,
                    "onUpdate:validateTo": _cache[12] || (_cache[12] = $event => ((_unref(validazione).valore_quietanza) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_44, [
                  _createTextVNode(_toDisplayString(_unref(validazione).tipo_mutuo.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tipo_mutuo.ref]
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createVNode(_component_base_select, {
                    name: "tipo_mutuo",
                    options: [{name: 'Fondiario', value: 'fondiario'},{name: 'Ipotecario', value: 'ipotecario'}],
                    isSelected: _unref(validazione).tipo_mutuo.value !== '',
                    state: __props.readonly === true ?'disable':'',
                    validateTo: _unref(validazione).tipo_mutuo,
                    "onUpdate:validateTo": _cache[13] || (_cache[13] = $event => ((_unref(validazione).tipo_mutuo) = $event))
                  }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_47, [
                  _createTextVNode(_toDisplayString(_unref(validazione).forma_del_titolo.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.forma_del_titolo.ref]
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createVNode(_component_base_select, {
                    name: "forma_del_titolo",
                    options: [{name: 'Pubblico', value: 'pubblico'},{name: 'Privato', value: 'privato'}],
                    isSelected: _unref(validazione).forma_del_titolo.value !== '',
                    state: __props.readonly === true ?'disable':'',
                    validateTo: _unref(validazione).forma_del_titolo,
                    "onUpdate:validateTo": _cache[14] || (_cache[14] = $event => ((_unref(validazione).forma_del_titolo) = $event))
                  }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                ])
              ]),
              (_unref(regimeFiscale) === 'ordinario')
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                    _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_50, [
                      _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                    ])), [
                      [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _createVNode(_component_base_input_checkbox, {
                        class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                        name: "ritenuta_acconto",
                        label: "Si, applicabile",
                        "validate-to": _unref(validazione).ritenuta_acconto,
                        "onUpdate:validateTo": _cache[15] || (_cache[15] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                      }, null, 8 /* PROPS */, ["class", "validate-to"])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createVNode(RegimeFiscale, {
                validazione: _unref(validazione),
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
              _createVNode(AliquoteContributiRepertoriali, {
                validazione: _unref(validazione),
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
              _createVNode(CalcoloEquoCompenso, {
                "input-riferimento-calcolo": "valore_quietanza",
                validazione: validazioneEquoCompenso.value,
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
            ]))
          : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}